export const JADWALS_GET = 'JADWALS_GET';
export const JADWAL_JENJANGS_GET = 'JADWAL_JENJANGS_GET';
export const JADWAL_YEARS_GET = 'JADWAL_YEARS_GET';
export const JADWAL_SEMS_GET = 'JADWAL_SEMS_GET';
export const JADWAL_KELASS_GET = 'JADWAL_KELASS_GET';
export const JADWAL_PELAJARANS_GET = 'JADWAL_PELAJARANS_GET';
export const JADWAL_GURUS_GET = 'JADWAL_GURUS_GET';
export const JADWAL_ADD = 'JADWAL_ADD';
export const JADWAL_EDIT = 'JADWAL_EDIT';
export const JADWAL_GET = 'JADWAL_GET';
export const JADWAL_SETTING_EDIT = 'JADWAL_SETTING_EDIT';
export const JADWAL_DELETE = 'JADWAL_DELETE';
export const JADWAL_SAVE_EVENTS = 'JADWAL_SAVE_EVENTS';
export const JADWAL_CLASH_TEACHERS = 'JADWAL_CLASH_TEACHERS';
